document.addEventListener('DOMContentLoaded', function () {

  // Legge il JSON delle varianti dal tema Pursuit
  const productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;

  let productData;
  try { productData = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

  const variants = (productData.product && productData.product.variants) || productData.variants || [];


  // --- GESTIONE DROPDOWN (single-option-selector) ---
  const optionSelects = document.querySelectorAll('.single-option-selector');

  function getSelectedFromSelects() {
    const opts = {};
    optionSelects.forEach((sel, i) => { opts[i + 1] = sel.value; });
    return opts;
  }

  function updateDropdowns() {
    if (!optionSelects.length) return;
    const selected = getSelectedFromSelects();

    optionSelects.forEach((sel, idx) => {
      const position = idx + 1;
      const otherOptions = { ...selected };

      Array.from(sel.options).forEach(opt => {
        const testOptions = { ...otherOptions, [position]: opt.value };
        const exists = variants.some(v =>
          Object.entries(testOptions).every(([pos, val]) => v['option' + pos] === val)
        );
        opt.disabled = !exists;
        if (!exists && !opt.text.endsWith(' ✕')) {
          opt.text = opt.value + ' ✕';
        } else if (exists) {
          opt.text = opt.value;
        }
      });
    });
  }

  optionSelects.forEach(sel => {
    sel.addEventListener('change', () => setTimeout(updateDropdowns, 10));
  });

  // --- GESTIONE SWATCHES (radio button con .swatch-element) ---
  const swatchContainers = document.querySelectorAll('.swatch[data-option-index]');

  function getSelectedFromSwatches() {
    const opts = {};
    swatchContainers.forEach(container => {
      const idx = parseInt(container.dataset.optionIndex);
      const checked = container.querySelector('input[type="radio"]:checked');
      if (checked) opts[idx + 1] = checked.value;
    });
    return opts;
  }

  function updateSwatches() {
    if (!swatchContainers.length) return;
    const selected = getSelectedFromSwatches();

    swatchContainers.forEach(container => {
      const idx = parseInt(container.dataset.optionIndex);
      const position = idx + 1;
      const otherOptions = { ...selected };

      container.querySelectorAll('.swatch-element').forEach(el => {
        const value = el.dataset.value;
        if (!value) return;

        const testOptions = { ...otherOptions, [position]: value };
        const exists = variants.some(v =>
          Object.entries(testOptions).every(([pos, val]) => v['option' + pos] === val)
        );

        const radio = el.querySelector('input[type="radio"]');
        if (!exists) {
          el.classList.add('soldout');
          el.classList.remove('available');
          if (radio) radio.setAttribute('disabled', 'disabled');
        } else {
          const exactVariant = variants.find(v =>
            Object.entries(testOptions).every(([pos, val]) => v['option' + pos] === val)
          );
          const isAvailable = exactVariant ? exactVariant.available : false;
          el.classList.toggle('soldout', !isAvailable);
          el.classList.toggle('available', isAvailable);
          if (radio) {
            if (isAvailable) radio.removeAttribute('disabled');
            else radio.setAttribute('disabled', 'disabled');
          }
        }
      });
    });
  }

  swatchContainers.forEach(container => {
    container.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => setTimeout(updateSwatches, 10));
    });
  });

  optionSelects.forEach(sel => {
    sel.addEventListener('change', () => setTimeout(updateSwatches, 20));
  });
  swatchContainers.forEach(container => {
    container.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => setTimeout(updateDropdowns, 20));
    });
  });

  // Inizializzazione
  updateDropdowns();
  updateSwatches();

});
